/**
 * External dependencies
 */
import { get } from 'lodash';

export const getLocationGroupId = state => get(state, 'ui.locationGroupModal.locationGroupId', "");